export * from './useOutsideClick';
export * from './useCancelScrollPage';
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy9pbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxtQkFBZDtBQUNBLGNBQWMsdUJBQWQiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgKiBmcm9tICcuL3VzZU91dHNpZGVDbGljayc7XG5leHBvcnQgKiBmcm9tICcuL3VzZUNhbmNlbFNjcm9sbFBhZ2UnO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/dist/hooks/index.js
// module id = 797
// module chunks = 118